import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

const CATEGORY_COLORS = {
  travel: '#A2D2FF',
  skills: '#B9FBC0',
  adventure: '#FFC8DD',
  relationships: '#FF6B6B',
  health: '#FDF0D5',
  creative: '#CDB4DB',
  career: '#FFE8A3',
  other: '#E0E0E0',
};

export default function TrophyUnlockCeremony({ item, onClose }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const t = setTimeout(onClose, 4200);
    return () => clearTimeout(t);
  }, [onClose]);

  if (!item) return null;
  const bg = CATEGORY_COLORS[item.category] || CATEGORY_COLORS.other;

  const rays = Array.from({ length: 14 });
  const confetti = Array.from({ length: 30 });
  const emojiBurst = ['🎊', '🌠', '✨', '🏆', '💫', '🎉', '⭐', '💖'];

  return (
    <div
      className="fixed inset-0 z-[80] bg-black/70 backdrop-blur-md flex items-center justify-center"
      data-testid="trophy-ceremony"
      onClick={onClose}
    >
      {/* Rays */}
      {rays.map((_, i) => (
        <span
          key={i}
          className="absolute left-1/2 top-1/2 origin-left pointer-events-none"
          style={{
            width: '30vw',
            height: '4px',
            zIndex: 5,
            background: `linear-gradient(90deg, rgba(255,215,0,0.7), rgba(255,215,0,0))`,
            transform: `rotate(${(i * 360) / rays.length}deg) translateX(60px)`,
            animation: mounted ? `trophy-rays 3.5s ease-out forwards` : 'none',
            filter: 'blur(2px)',
          }}
        />
      ))}

      {/* Confetti */}
      {confetti.map((_, i) => {
        const left = Math.random() * 100;
        const delay = Math.random() * 0.6;
        const duration = 2 + Math.random() * 1.5;
        const rotate = (Math.random() - 0.5) * 720;
        const char = emojiBurst[i % emojiBurst.length];
        return (
          <span
            key={i}
            className="absolute text-2xl pointer-events-none"
            style={{
              left: `${left}%`,
              top: '-40px',
              animation: mounted ? `trophy-confetti ${duration}s ease-in ${delay}s forwards` : 'none',
              transform: `rotate(${rotate}deg)`,
            }}
          >
            {char}
          </span>
        );
      })}

      {/* Trophy card */}
      <div
        className="relative z-10 neo-card p-8 max-w-md text-center"
        style={{
          background: `linear-gradient(135deg, ${bg} 0%, #FFF8E8 100%)`,
          animation: mounted ? 'trophy-pop 0.9s cubic-bezier(0.2, 1.2, 0.4, 1) forwards' : 'none',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 neo-btn p-1.5 bg-white"
          data-testid="trophy-close-btn"
        >
          <X className="w-4 h-4" />
        </button>
        <p className="text-[10px] font-bold uppercase tracking-[0.3em] opacity-70 mb-1">Dream unlocked</p>
        <div
          className="w-24 h-24 mx-auto rounded-full border-[4px] border-black flex items-center justify-center text-5xl shadow-[5px_5px_0px_0px_rgba(0,0,0,1)]"
          style={{ background: '#FDF0D5', animation: mounted ? 'trophy-spin 3s ease-in-out infinite' : 'none' }}
        >
          {item.emoji || '🏆'}
        </div>
        <h2 className="mt-4 text-2xl font-bold font-['Fredoka']">{item.title}</h2>
        <p className="mt-1 text-xs opacity-75">+15 points · Trophy added to your wall 🏆</p>
        <button
          onClick={onClose}
          className="mt-5 neo-btn px-6 py-2 bg-[#A2D2FF] font-bold"
          data-testid="trophy-continue-btn"
        >
          Fortsätt ✨
        </button>
      </div>
    </div>
  );
}
